import { yupResolver } from '@hookform/resolvers/yup'
import React, { FC, useContext, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'

import { AuthContext, VehicleDetailContext } from '../../providers'
import { useUpdateVehicleDetailMutation } from '../../redux/api'
import { loggingAssert } from '../../utils/handleError/loggingAssert'
import { EditableNotes, ErrorMessageWrapper } from '../SharedUI'
import { VEHICLE_NOTES_VALIDATION } from './validation'

interface Props {}
type FormValues = {
  notes: string
}

export const VehicleNotesForm: FC<Props> = () => {
  const [editing, setEditing] = useState(false)
  const [updateVehicleInfo, { error, isLoading }] =
    useUpdateVehicleDetailMutation()
  const { vehicleId, oldVehicleInfo } = useContext(VehicleDetailContext)
  const { currentUser, userShopId } = useContext(AuthContext)

  const { handleSubmit, control } = useForm({
    mode: 'onBlur',
    defaultValues: {
      notes: oldVehicleInfo?.notes || ''
    },
    resolver: yupResolver(VEHICLE_NOTES_VALIDATION)
  })
  const submitHandler: SubmitHandler<FormValues> = async (data) => {
    await updateVehicleInfo({
      authorization: loggingAssert('Token not set', currentUser!.accessToken),
      vehicleEntry: {
        id: vehicleId,
        shop: loggingAssert('ShopId not set', userShopId),
        info: {
          ...oldVehicleInfo,
          notes: data.notes
        }
      }
    })
    setEditing(false)
  }
  return (
    <ErrorMessageWrapper errorMessage={error} loading={isLoading}>
      <form onSubmit={handleSubmit(submitHandler)}>
        <EditableNotes
          editing={editing}
          setEditing={setEditing}
          notes={oldVehicleInfo?.notes as string}
          control={control}
        />
      </form>
    </ErrorMessageWrapper>
  )
}
